import React, { useState } from 'react';
import {Subheader} from "@/Components/Subheader";
import {Container} from "@/Components/Container";

export function Carousel({}) {
    const slides = [
        {
            title: 'Set up the tool',
            subheader: 'TAKE ACTIONS TO REDUCE CO₂',
            description: 'Add multiple departments and reporters to simplify reporting across the organisation. Add questions and choose emission factors from our global database or create your own. Add reporters to tasks and customize reporting categories based on you goal and scope.',
            image: 'images/actions-to-reduce-co2.png',
            controls_label: 'Fill in the numbers',
        },
        {
            title: 'Fill in the numbers',
            subheader: 'REQUEST ACTIVITY DATA',
            description: 'Start filling in the numbers, keep track of your reporters and follow up on progress. Emma calculates emission performance automatically. Add new tasks and teams whenever and request data from suppliers if necessary.',
            image: 'images/request-activity-data.png',
            controls_label: 'Get your report',
        },
        {
            title: 'Get your report',
            subheader: 'ANALYSE YOUR ENVIRONMENTAL PERFORMANCE',
            description: 'Your statistics are always available via Results. Analyse your environmental performance and understand you emission hot-spots. Start implement actions to reduce CO₂ emissions.',
            image: 'images/analyse-your-performance.png',
            controls_label: '',
        },
    ];

    const [counter, setCounter] = useState(0);
    const currentSlide = slides[counter];

    const handleNext = () => {
        setCounter((prevCounter) => (prevCounter + 1) % slides.length);
    };

    return (
        <div className="bg-white pt-16 pb-4">
            <Container size="max-w-[1024px] carousel-box">
                <div className='flex items-center md:items-start flex-col md:flex-row gap-8 p-8 border-0 border-b border-[#CCDADF]'>
                    <div className="w-full md:w-1/2 flex flex-col justify-start items-start relative z-[100]">
                        <Subheader margin={'mb-4'} className={'font-normal text-[#668E9F]'}>{currentSlide.subheader}</Subheader>
                        <h3 className="font-bold text-[20px] leading-[22px] text-primary">{currentSlide.title}</h3>
                        <p className="mt-2 mb-4 text-primary">{currentSlide.description}</p>
                    </div>
                    <div className="w-full md:w-1/2">
                        <img className="m-auto mb-2 mb:mb-0 relative z-[100]" src={currentSlide.image} alt={currentSlide.title} />
                    </div>
                </div>
                <div className="flex items-center justify-between p-4">
                    <div>
                        <span className={`w-[10px] h-[10px] mr-2 inline-block ${counter === 0 ? 'bg-primary' : 'bg-[#C4C4C4]'}`}></span>
                        <span className={`w-[10px] h-[10px] mr-2 inline-block ${counter === 1 ? 'bg-primary' : 'bg-[#C4C4C4]'}`}></span>
                        <span className={`w-[10px] h-[10px] inline-block ${counter === 2 ? 'bg-primary' : 'bg-[#C4C4C4]'}`}></span>
                    </div>
                    <div onClick={handleNext} className="cursor-pointer flex gap-2">
                        <button className="text-primary" type="button"> <span className="font-bold">{counter !== 2 ?'Next step:' : 'Start over'}</span> {currentSlide.controls_label} </button>
                        <img src={'images/arrow-right-circle.svg'} alt="arrow-right" />
                    </div>
                </div>
            </Container>
        </div>
    );
}






